<h2 class="center-page-heading">{{ "settings_general_page_heading" | translate }}</h2>
<p class="center-page-description">{{ "settings_general_page_description" | translate }}</p>

<p-card class="md:mx-[-2rem] mt-6 mb-2 p-4">
    @if (isInitDone) {
        <h5>{{ "settings_general_organisation_heading" | translate }}</h5>
        <p class="mb-12">{{ "settings_general_organisation_description" | translate }}</p>

        <div class="grid grid-cols-12 gap-4 mb-12">
            <div class="col-span-12 md:col-span-3">
                <label class="block mb-2 font-weight-600" for="companyName">{{ "settings_general_organisation_name" | translate }}</label>
                <input id="companyName" type="text" pInputText fluid [(ngModel)]="companyName" />
                <button pButton pRipple type="button" class="p-button-raised mt-4" (click)="saveCompanyName()">{{ "button_save" | translate }}</button>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 md:col-span-6">
                <div class="p-fluid">
                    <label class="font-weight-600" for="companyLogo">
                        {{ "settings_general_organisation_logo_heading" | translate }}
                    </label>
                    <p class="mt-4 mb-4">{{ "settings_general_organisation_logo_description" | translate }}</p>
                    @if (companyLogo) {
                        <img data-testid="settings-logo-image" [src]="companyLogo" class="company-logo-image" alt="Company Logo (missing)" />
                    }
                    <div class="company-logo-container mt-4">
                        <input data-testid="settings-logo-input" type="file" accept="image/*" (change)="onFileSelected($event)" hidden #fileInput />

                        <button
                            data-testid="settings-logo-upload"
                            [disabled]="!licenseStatePro"
                            pButton
                            pTooltip="{{ 'settings_general_organisation_logo_proFeature' | translate }}"
                            [tooltipDisabled]="licenseStatePro"
                            tooltipPosition="top"
                            type="button"
                            (click)="fileInput.click()"
                            class="p-button-raised"
                        >
                            <i class="pi pi-upload"></i>
                            {{ (companyLogo ? "change-logo-upload-label" : "logo-upload-label") | translate }}
                        </button>
                        @if (companyLogo) {
                            <button
                                data-testid="settings-logo-delete"
                                pButton
                                severity="danger"
                                pRipple
                                pTooltip="{{ 'delete-logo-upload-label' | translate }}"
                                type="button"
                                (click)="removeLogo()"
                                class="p-button-outlined p-button-raised ml-2"
                            >
                                <i class="pi pi-trash"></i>
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div style="height: 3rem">&nbsp;</div>

        <h5 class="mt-4">{{ "settings_general_timetracking_heading" | translate }}</h5>

        <div class="grid grid-cols-12 gap-4 mb-6 mt-4">
            <div class="col-span-12 lg:col-span-8">
                <form [formGroup]="retroactiveEditForm.form" class="flex flex-col gap-4 mt-6">
                    <div>
                        <span
                            class="flex items-center gap-2"
                            pTooltip="{{ 'settings_general_retroactiveEditLimit_proFeature' | translate }}"
                            [tooltipDisabled]="licenseStatePro"
                            tooltipPosition="top"
                        >
                            <p-toggleswitch
                                data-testid="settings-retroactive-edit-toggle"
                                formControlName="enabled"
                                [disabled]="!licenseStatePro"
                            ></p-toggleswitch>
                            <label class="radio-label m-0"> {{ "settings_general_retroactiveEditLimit_title" | translate }} </label>
                        </span>
                    </div>

                    @if (retroactiveEditForm.isEnabled) {
                        <div class="ml-12 flex flex-col gap-4">
                            <div class="">{{ "settings_general_retroactiveEditLimit_info" | translate }}</div>

                            <div class="flex items-center gap-3">
                                <p-radioButton
                                    data-testid="settings-retroactive-edit-today"
                                    name="mode"
                                    inputId="range-today"
                                    value="today"
                                    formControlName="mode"
                                >
                                </p-radioButton>
                                <label for="range-today" class="radio-label">
                                    {{ "settings_general_retroactiveEditLimit_option_today" | translate }}
                                </label>
                            </div>
                            <div class="flex items-start sm:items-center gap-3" style="margin-top: -6px">
                                <p-radioButton name="mode" inputId="range-days" value="days" formControlName="mode"> </p-radioButton>
                                <label
                                    for="range-days"
                                    class="radio-label flex flex-col items-start gap-1 sm:flex-row sm:items-center sm:gap-2 sm:whitespace-nowrap"
                                >
                                    <span class="text-base">
                                        {{ "settings_general_retroactiveEditLimit_option_up_to_1" | translate }}
                                    </span>

                                    <p-inputNumber
                                        data-testid="settings-retroactive-edit-days"
                                        formControlName="days"
                                        [min]="1"
                                        [max]="365"
                                        [showButtons]="true"
                                        buttonLayout="horizontal"
                                        class="retro-days-number"
                                        inputStyleClass="w-20 sm:w-18 text-center"
                                    />

                                    <span class="text-base">
                                        {{ "settings_general_retroactiveEditLimit_option_up_to_2" | translate }}
                                    </span>
                                </label>
                            </div>
                            <div>{{ "settings_general_retroactiveEditLimit_info2" | translate }}</div>
                        </div>
                    }
                </form>
            </div>
        </div>

        <h5 class="mt-12">
            {{ "settings_general_time_budgets_heading" | translate }}
            <span class="integration-state beta-state ml-2" pTooltip="{{ 'beta_feature' | translate }}" tooltipPosition="top">BETA</span>
        </h5>
        <p>{{ "settings_general_time_budgets_description" | translate }}</p>

        <div class="mt-6 mb-6">
            <span
                class="inline-flex items-center gap-2"
                pTooltip="{{ 'time_budget_proFeature' | translate }}"
                [tooltipDisabled]="licenseStatePro"
                tooltipPosition="top"
            >
                <p-toggleswitch
                    data-testid="settings-time-budgets-toggle"
                    inputId="settings-time-budgets"
                    [(ngModel)]="timeBudgetsEnabled"
                    (onChange)="saveTimeBudgetsEnabled($event.checked)"
                    [disabled]="!licenseStatePro"
                />
                <label for="settings-time-budgets" class="radio-label m-0">{{ "settings_general_time_budgets_toggle" | translate }}</label>
            </span>
            <!-- nested -->
            @if (isMultiUserAccount && timeBudgetsEnabled) {
                <div class="mt-4 ml-12">
                    <span
                        class="inline-flex items-center gap-2"
                        pTooltip="{{ 'time_budget_proFeature' | translate }}"
                        [tooltipDisabled]="licenseStatePro"
                        tooltipPosition="top"
                    >
                        <p-toggleswitch
                            data-testid="settings-time-budgets-visible-to-all-users-toggle"
                            inputId="settings-time-budgets-visible-to-all-users"
                            [(ngModel)]="timeBudgetsVisibleToAllUsers"
                            (onChange)="saveTimeBudgetsVisibleToAllUsers($event.checked)"
                            [disabled]="!licenseStatePro"
                        />
                        <label for="settings-time-budgets-visible-to-all-users" class="radio-label m-0">{{
                            "settings_general_time_budgets_visible_to_all_users_toggle" | translate
                        }}</label>
                    </span>
                </div>
            }
        </div>
    }
</p-card>
